// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3pOKu","content":"style_content__1II4c","collapseBtn":"style_collapseBtn__3eTRJ"};